export default __webpack_public_path__ + "locales/ro/EmptyView.json?hash=0add83e125b02506eb3117a8cc5c5089";